// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__cXP6h","glow":"App_glow__INAfO"};